<template>
  <div class="ctn">
    <div class="hdr-tools">
      <div class="input-item">
        <div class="hdr-tools-name">密钥名:</div>
        <el-input size="mini" class="hdr-tools-input" v-model="name" @click="postFile" />
      </div>

      <div class="input-item">
        <div class="hdr-tools-name">密钥密码:</div>
        <el-input size="mini" class="hdr-tools-input" v-model="password" show-password @click="postFile" placeholder="加密的密钥需要" />
      </div>

<!--      <el-upload action="" :show-file-list="false" :http-request="postFile" :auto-upload="false" :on-change="changeHandler">-->
<!--        <el-button size="mini" class="hdr-tools-btn">选择密钥</el-button>-->
<!--      </el-upload>-->
      <el-button class="hdr-tools-btn" size="mini" @click="clear">清空</el-button>
      <el-button class="hdr-tools-btn" size="mini" type="primary" @click="postFile">添加</el-button>
    </div>

    <div class="validate-result">{{tips}}</div>

    <div class="drag-area">
      <el-upload action="" class="uplaoder" :show-file-list="false" :http-request="postFile" :auto-upload="false" :on-change="changeHandler" drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将密钥文件拖到此处，或<em>选择文件</em></div>
      </el-upload>

      <el-upload action="" class="uplaoder" :show-file-list="false" :http-request="postFile" :auto-upload="false" :on-change="changePublicKeyHandler" drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将公钥文件拖到此处，或<em>选择文件</em></div>
      </el-upload>
    </div>

    <key-with-tool v-if="text" :text="text" title="Private Key" />
    <key-with-tool v-if="publicText" :text="publicText" title="Public Key" />
    <key-with-tool v-if="sshAuthorizedKeyText" :text="sshAuthorizedKeyText" title="SSH Authorized Key" />
  </div>
</template>

<script>
import keyWithTool from './keyWithTool'
import KeyWithTool from "./keyWithTool";
export default {
  name: "newKey",
  components: {KeyWithTool, keyWithTool},
  data() {
    return {
      name: undefined,
      tips: undefined,  // undefined 表示未经验证, 验证通过则为 ""
      password: "",
      text: undefined,
      publicText: undefined,
      sshAuthorizedKeyText: undefined,
    }
  },
  watch: {
    name: function() {
      if (this.name === "" || this.name === undefined) {
        this.tips = "密钥名不能为空"
        return
      }

      let self = this
      this.api.hifs.getPath(self.path, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          self.tips = "检查同名密钥是否存在出错"
        } else {
          // 文件已存在
          if (data == true) {
            self.tips = "同名密钥已存在"
            return
          }
          self.tips = ""
        }
      })
    }
  },
  computed: {
    path: function() {
      return `/keys/${this.name}`
    },
  },
  methods: {
    postFile() {
      if (this.name === "" || this.name === undefined) {
        this.tips = "invalid name"
        return
      }

      if (this.text === "" || this.text === undefined) {
        this.tips = "invalid private key"
        return
      }

      let self = this
      this.api.hifs.getPath(self.path, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          self.tips = "检查同名密钥是否存在出错"
        } else {
          // 文件已存在
          console.log("get path data:", data)
          if (data == true) {
            self.tips = "同名密钥已存在"
            return
          }

          // 没有设置密码，直接上传
          if (!self.password) {
            // 文件不存在, 上传密钥
            self.tips = ""
            let keyPair = new self.model.KeyPair()
            keyPair.PrivateKey = self.text
            keyPair.Passphrase = self.password
            keyPair.PublicKey = self.publicText
            keyPair.SshAuthorizedKey = self.sshAuthorizedKeyText

            let blob = new Blob([JSON.stringify(keyPair)])
            self.api.hifs.postFile(self.path, blob, (error, data, response) => {
              if (error) {
                self.api.errHandler(self, error, response)
              } else {
                // console.log("postFile success data:", data)
                self.$message.success(`添加密钥 ${self.name} 成功`)
                self.$emit("addSuccess")
              }
            })
          } else {
            let opts = {
              'password': self.password // String | 密码
            };
            self.api.sess.getSessionPasswordEncrypted(opts, (error, data, response) => {
              if (error) {
                self.api.errHandler(self, error, response)
              } else {
                // 获取加密后的密码成功
                console.log("encrypted password success:", data)

                // 文件不存在, 上传密钥
                self.tips = ""
                let keyPair = new self.model.KeyPair()
                keyPair.PrivateKey = self.text
                keyPair.Passphrase = data
                keyPair.PublicKey = self.publicText
                keyPair.SshAuthorizedKey = self.sshAuthorizedKeyText

                let blob = new Blob([JSON.stringify(keyPair)])
                self.api.hifs.postFile(self.path, blob, (error, data, response) => {
                  if (error) {
                    self.api.errHandler(self, error, response)
                  } else {
                    // console.log("postFile success data:", data)
                    self.$message.success(`添加密钥 ${self.name} 成功`)
                    self.$emit("addSuccess")
                  }
                })
              }
            })
          }
        }
      })
    },
    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    // args: (file, fileList)
    changeHandler: function(file) {
      let self = this
      this.name = file.name

      let reader = new FileReader()
      reader.readAsText(file.raw)
      reader.onload = () => {
        self.text = reader.result
      }
    },
    // args: (file, fileList)
    changePublicKeyHandler: function (file) {
      let self = this
      let reader = new FileReader()
      reader.readAsText(file.raw)
      reader.onload = () => {
        let text = reader.result
        if (text.search(/ssh-/i) === 0) {
          console.log("pub file is ssh authorized key")
          self.sshAuthorizedKeyText = text
        } else if (text.search(/----/i) === 0) {
          console.log("pub file is public key")
          self.publicText = text
        } else {
          self.$message.error("invalid public key")
        }
      }
    },
    clear: function() {
      this.text = undefined
      this.password = undefined
      this.publicText = undefined
      this.sshAuthorizedKeyText = undefined
      this.name = undefined
      this.$nextTick(() => {
        this.tips = undefined
      })
    },
  },
}
</script>

<style scoped>
.ctn {
  display: flex;
  flex-direction: column;
}
.hdr-tools {
  display: flex;

  justify-content: space-between;
}
.input-item {
  display: flex;
  align-items: baseline;
}
.hdr-tools-name {
  flex-grow: 0;
  padding-right: 0.5em;
  word-break: keep-all;

  user-select: none;
}
.hdr-tools-input {
  width: 130px;
}

.drag-area {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.uplaoder {
  margin-top: 16px;

  flex-grow: 1;
}
.validate-result {
  width: 100%;
  padding-top: 0.6em;
  font-size: 0.8em;

  display: flex;
  justify-content: flex-end;
  color:brown;
}

/deep/
.el-upload {
  width: 100%;
}

/deep/
.el-upload-dragger {
  width: 100%;
  height: 150px;
}
</style>
